// src/components/Assessment/AssessmentFlow.jsx

import React from 'react';
import {
  Button,
  Icon,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaCheckCircle } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

// Import the reusable assessment engine
import AssessmentEngine from './AssessmentEngine';
// Import questions configuration
import { assessmentQuestions } from './assessmentQuestions';
// Import services
import { assessmentService, getFallbackRecommendation } from '../../services/assessmentService';

const AssessmentFlow = ({
  buttonText = "Check if the program is right for me?",
  onAssessmentComplete,
  customQuestions, // Optional: allow custom questions
  customResultsComponent, // Optional: allow custom results component
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  
  const modalBg = useColorModeValue("white", "gray.800");
  
  // Use custom questions if provided, otherwise use default
  const questions = customQuestions || assessmentQuestions;

  const handleViewDetails = (path) => {
    onClose();
    navigate(path);
  };

  const handleAssessmentComplete = (answers, recommendation) => {
    if (onAssessmentComplete) {
      onAssessmentComplete(answers, recommendation);
    }
  };

  return (
    <>
      <Button 
        onClick={onOpen} 
        size="lg" 
        color="white" 
        leftIcon={<Icon as={FaCheckCircle} />}
      >
        {buttonText}
      </Button>

      <Modal
        isOpen={isOpen}
        onClose={onClose}
        size="5xl"
        scrollBehavior="inside"
        autoFocus={false}
        blockScrollOnMount={false}
      >
        <ModalOverlay bg="blackAlpha.600" backdropFilter="blur(12px)" />
        <ModalContent p={8} borderRadius="2xl" bg={modalBg}>
          <ModalCloseButton />
          
          <AssessmentEngine
            questions={questions}
            assessmentService={assessmentService}
            getFallbackRecommendation={getFallbackRecommendation}
            onViewDetails={handleViewDetails}
            onAssessmentComplete={handleAssessmentComplete}
            customResultsComponent={customResultsComponent}
            onClose={onClose}
          />
        </ModalContent>
      </Modal>
    </>
  );
};

export default AssessmentFlow;